export const OPAL_BRAND_NAME = "Opal";
export const MARK_BRAND_NAME = "Mark";

/**
 * Rewrites the standalone word "Opal" in static UI copy to the rebranded name.
 *
 * Only ever call this on copy we author. Product, instance, user group and role names come from
 * the API and must keep reading "Opal" so they stay matchable against the backend.
 */
export const renameOpalCopy = (copy: string, renameEnabled: boolean): string =>
    renameEnabled ? copy.replace(/\bOpal\b/g, MARK_BRAND_NAME) : copy;
